<template>

    <filters-and-pagination
        :pagination-data="filtersAndPaginationData"
        :data-exists="dataExists"
        :loading-data="loadingFiltersAndPaginationData"
        :showTableFilter="false"
        model-name="intermediary-payouts"
    >

        <table class="min-w-full divide-y divide-gray-200">
            <thead>
            <tr class="h-1">
                <th :colspan="9">
                    <progress-bar v-if="loadingFiltersAndPaginationData"/>
                </th>
            </tr>
            <tr>
                <th scope="col"
                    class="px-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                    Charge Status
                </th>
                <th scope="col"
                    class="px-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                    Payout Status
                </th>
                <th scope="col"
                    class="px-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                    Total Amount
                </th>
                <th scope="col"
                    class="pl-8 pr-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                    Charged Amount
                </th>
                <th scope="col"
                    class="px-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                    Paid Amount
                </th>
                <th scope="col"
                    class="px-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                    Payout at
                </th>
                <th scope="col"
                    class="px-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                    Charged at
                </th>
                <th scope="col"
                    class="px-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                    Paid at
                </th>
                <th scope="col"
                    class="px-4 py-3 text-right text-xs font-normal text-gray-500 uppercase tracking-wider">
                    Action
                </th>
            </tr>
            <tr class="h-1"/>
            </thead>
            <tbody class="divide-y divide-gray-200">
            <initial-loading-skeleton-rows
                v-if="loadingFiltersAndPaginationData && (!filtersAndPaginationData.data || filtersAndPaginationData.data?.length === 0)"
                :number-of-table-columns="9"
            />
            <no-search-data-row
                v-else-if="!loadingFiltersAndPaginationData && filtersAndPaginationData.data?.length === 0"
                :number-of-table-columns="9"
            />
            <template v-else>
                <tr v-for="payout in filtersAndPaginationData.data" class="hover:bg-gray-50 group">
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                    <span
                        class="inline-flex items-center px-1.5 py-0.5 rounded text-xs border align-middle font-medium"
                        :class="{
                        'bg-teal-100 text-teal-800 border-teal-100': (payout.charged_raw_status || null) === 'succeeded' || (payout.charged_raw_status || null) === 'in_progress',
                        'bg-pink-100 text-pink-800 border-pink-100': (payout.charged_raw_status || null) === 'failed',
                        'bg-gray-100 text-gray-800 border-gray-100': (payout.charged_raw_status || null) === null,
                        }"
                    >{{ payout.charged_status || 'Waiting' }}</span>
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-900">

                        <span
                            class="inline-flex items-center px-1.5 py-0.5 rounded text-xs border align-middle font-medium"
                            :class="{
                        'bg-teal-100 text-teal-800 border-teal-100': (payout.payout_raw_status || null) === 'succeeded' || (payout.payout_raw_status || null) === 'in_progress',
                        'bg-pink-100 text-pink-800 border-pink-100': (payout.payout_raw_status || null) === 'failed',
                        'bg-gray-100 text-gray-800 border-gray-100': (payout.payout_raw_status || null) === null,
                        }"
                        >{{ payout.payout_status || 'Waiting' }}</span>
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {{ payout.payouts_total_amount }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {{ payout.charged_amount }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {{ payout.paid_out_amount }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ payout.payout_at }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ payout.charged_at }}
                    </td>
                    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ payout.paid_out_at }}
                    </td>
                    <td class="px-4 py-4">
                        <modal title="Payout requests" cancel_btn_title="Close" size="medium" name="payout-details-modal">
                            <template #toggle>
                                <btn type="light" size="small" class="whitespace-nowrap">
                                    View details
                                </btn>
                            </template>
                            <template #body>
                                <div class="grid gap-9 lg:grid-cols-2">
                                    <div v-if="payout && (payout.partner_payouts ?? []).length > 0"
                                         class="lg:col-span-2">
                                        <div class="bg-white rounded overflow-hidden border">
                                            <div class="overflow-x-auto">
                                                <div
                                                    class="align-middle inline-block min-w-full">
                                                    <table class="min-w-full mt-1 divide-y divide-gray-200">
                                                        <thead>
                                                        <tr>
                                                            <th scope="col"
                                                                class="pl-6 pr-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                                                                Name
                                                            </th>
                                                            <th scope="col"
                                                                class="px-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                                                                Date
                                                            </th>
                                                            <th scope="col"
                                                                class="px-4 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider">
                                                                Amount
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody class="bg-white divide-y divide-gray-200">
                                                        <tr
                                                            @click="redirectToPartnerPayout(item)"
                                                            v-for="item in (payout.partner_payouts ?? [])"
                                                            class="hover:bg-gray-50 cursor-pointer group">
                                                            <td class="pl-6 pr-4 py-3 whitespace-nowrap font-semibold text-sm text-gray-900">
                                                                {{ item['partner_full_name'] || 'n/a' }}
                                                                <div
                                                                    v-if="item['partner_email'] ?? null"
                                                                    class="text-sm font-normal text-gray-500">
                                                                    {{ item['partner_email'] }}
                                                                </div>
                                                            </td>
                                                            <td class="px-4 py-3 whitespace-nowrap font-medium text-sm text-gray-900">
                                                                {{ item['date'] || 'n/a' }}
                                                            </td>
                                                            <td class="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                {{ item['amount'] || 'n/a' }}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </modal>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
    </filters-and-pagination>

</template>
<script setup>

import {ref, onMounted} from "vue";
import ProgressBar from "../../../../elements/ProgressBar.vue";
import NoSearchDataRow from "../../../common/NoSearchDataRow";
import useFiltersAndPagination from "../../../../state/common/filters-and-pagination";
import FiltersAndPagination from "../../filters-and-pagination/FiltersAndPagination.vue";
import useRecentActivities from "../../../../composables/common/filter-and-pagination-data";
import InitialLoadingSkeletonRows from "../../../common/InitialLoadingSkeletonRows.vue";

const props = defineProps({
    program: {
        type: [String, Number],
        required: true
    }
});

const dataExists = ref(false);

const {loadingFiltersAndPaginationData, filtersAndPaginationData, getFiltersAndPaginationData} = useRecentActivities();
const {setDataBaseUrl, setFetchDataFunction} = useFiltersAndPagination();

onMounted(() => {
    setDataBaseUrl(route('app_int.intermediary_payouts.list', {program: props.program}));
    setFetchDataFunction(getFiltersAndPaginationData);
});

const redirectToPartnerPayout = (payout) => {
    window.location.href = payout.url;
}

</script>

<style scoped></style>
